export const QUICK_EXIT_DESTINATION_URL = 'https://www.google.com';
export const ESC_DOUBLE_CLICK_INTERVAL_MS = 500;
export const TAP_AND_HOLD_FINGERS = 2;
export const TAP_AND_HOLD_TIMEOUT_MS = 1000;
export const TAP_AND_HOLD_MOVE_THRESHOLD_PX = 30;
export const QUICK_EXIT_BUTTON_ID = 'quick-exit-button';
